import { defineComponent as _defineComponent } from 'vue'
import { mdiMenuDown } from '@mdi/js';

interface IProps {
  value?: IItem;
  items?: IItem[];
}

interface IItem {
  text?: string;
  label?: string;
  value: string;
}

interface IEmits {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'Value', value: any | undefined): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'change', e: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltroOrdenacao',
  props: {
    value: null,
    items: null
  },
  emits: ["Value", "change"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'Value', value: any | undefined): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'change', e: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: IItem;
  items?: IItem[];
};





const setItem = (item: IItem) => {
  const useProps = props;
  if (useProps) return emit('change', item);
};

return { __sfc: true,props, emit, setItem, mdiMenuDown }
}

})